import React from 'react';
// import '../../assets/black.png'; // FIXME need to add arrow to the button

const Button = ({
  button,
}) => {
  const { text, url } = button;
  return (text && url) && 
  (
    <div className="button-container">
      <a className='button btn-text' href={url} data-link-type="cta-link" rel="noopener noreferrer">
        <img className="arrow" src="https://gmg-static-assets.s3.amazonaws.com/minisite-assets/ally-bank/misc/black.png"></img>
        <span>{text}</span>
      </a>
    </div>
  );
};

export default Button;
